module.exports = "img/37.8cbd1b.webp";